import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';

export default function BrandDetails() {
  const [brandName, setBrandName] = useState('');
  const [loading, setLoading] = useState(false);

  // Brand name'i çek
  const fetchBrandName = async () => {
    try {
      setLoading(true);
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.error('No brand ID found in localStorage');
        return;
      }

      const response = await fetch(`https://api.glowytics.com/api/brands/${brandId}/details`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch brand name');
      }

      const data = await response.json();
      console.log('Brand details fetched:', data);
      
      if (data && data.name) {
        setBrandName(data.name);
      }
    } catch (error) {
      console.error('Error fetching brand name:', error);
      toast.error('Failed to fetch brand details');
    } finally {
      setLoading(false);
    }
  };

  // Brand detaylarını kaydet
  const handleSaveBrandDetails = async () => {
    try {
      setLoading(true);
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        toast.error('No brand selected. Please select a brand first.');
        return;
      }

      const response = await fetch(`https://api.glowytics.com/api/brands/${brandId}/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
        body: JSON.stringify({
          name: brandName
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update brand details');
      }

      // Show success message
      toast.success('Brand details updated successfully');
    } catch (error) {
      console.error('Error updating brand details:', error);
      toast.error('Failed to update brand details');
    } finally {
      setLoading(false);
    }
  };

  // Sayfa yüklendiğinde brand name'i getir
  useEffect(() => {
    fetchBrandName();
  }, []);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden p-6">
      <h2 className="text-xl font-semibold mb-4">Brand Details</h2>
      <div className="space-y-4">
        {/* Brand Name Input */}
        <div className="mb-4">
          <label htmlFor="brandName" className="block text-sm font-medium text-gray-700 mb-1">
            Brand Name
          </label>
          <input
            type="text"
            id="brandName"
            name="brandName"
            value={brandName}
            onChange={(e) => setBrandName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter your brand name"
            disabled={loading}
          />
        </div>
        
        {/* Save Button */}
        <button
          onClick={handleSaveBrandDetails}
          disabled={loading}
          className={`px-4 py-2 ${loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'} text-white rounded-md transition-colors`}
        >
          {loading ? 'Saving...' : 'Save Brand Details'}
        </button>
      </div>
    </div>
  );
} 